import React from 'react';
import { Avatar } from './Avatar';

export const Avatars = ({ items = [], maxAvatars = 3, hideImage = false, size = 'xsmall', className = 'avatars' }) => {
  if (!items.length) return null;

  const visibleAvatars = items.slice(0, maxAvatars);
  const hiddenAvatars = items.slice(maxAvatars);
  const remainderCount = hiddenAvatars.length;

  return (
    <span className={className}>
      {visibleAvatars.map(({ id, ...item }) => (
        <Avatar
          key={id}
          {...item}
          size={size}
          showTooltip
          hideImage={hideImage}
        />
      ))}

      {remainderCount > 0 && (
        <Avatar
          remainder={remainderCount}
          tooltipText={hiddenAvatars.map(item => item.label)}
          size={size}
          primaryBg
          showTooltip
        />
      )}
    </span>
  );
};
